var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React, { useEffect } from "react";
import { useState } from "react";
import { useTrans } from "@utils/langs/useTrans";
import { useRecoilState, useSetRecoilState } from "recoil";
import { useAsync } from "react-async";
import { PromiseHttp } from "@utils/api/HttpUtil";
import { useLocation, useNavigate } from "react-router-dom";
import { items, menuAdmin, resets, url } from "@recoil/Store";
import * as Const from "@utils/Const";
export default function AdminHeader(props) {
    const { pathname } = useLocation();
    const navigate = useNavigate();
    const t = useTrans();
    const langs = !localStorage.getItem(Const.LANG_TYPEA) ? "KOR" : localStorage.getItem(Const.LANG_TYPEA);
    const [lang, setLang] = useState(langs);
    const setUrl = useSetRecoilState(url);
    const setMenus = useSetRecoilState(menuAdmin);
    const setItem = useSetRecoilState(items);
    const [reset, setReset] = useRecoilState(resets);
    const tab = [
        { name: "메뉴 관리", url: Const.URL_ADMIN, id: 0 },
        { name: "제품 관리", url: Const.URL_PRODUCTSMANAGEMENT, id: 1 },
        { name: "게시판 관리", url: Const.URL_BOARDMANAGEMENT, id: 2 },
        // ⭐ 보안 관리 탭 추가
        { name: "보안 관리", url: Const.URL_SECURITY, id: 3 }
    ];
    let token = localStorage.getItem(Const.TOKEN);
    // API
    const { data: data } = useAsync({
        promiseFn: PromiseHttp,
        httpMethod: Const.API_GET,
        appPath: `/admin/menu/list?lang=${lang}`,
        appQuery: {},
        userToken: token,
        watch: pathname + reset + lang,
    });
    useEffect(() => {
        if (data) {
            if (data.codeNum == Const.API_200) {
                const datas = data.body.map((val) => (Object.assign(Object.assign({}, val), { tabUrl: (val.url === Const.URL_PRODUCTS) ? Const.URL_PRODUCTSMANAGEMENT : val.url === Const.URL_NOTICE ? Const.URL_BOARDMANAGEMENT : null })));
                let menu = datas.filter((item) => (item.tabUrl === pathname))[0];
                if (pathname === Const.URL_ADMIN) {
                    setItem({
                        depth1: datas[0],
                        depth2: null,
                        type: Const.TYPE_V,
                        tab: Const.AD_M
                    });
                }
                else if (pathname === Const.URL_PRODUCTSMANAGEMENT) {
                    setItem({
                        depth1: menu && menu,
                        depth2: menu && menu.subMenus[0],
                        type: Const.TYPE_L,
                        tab: Const.AD_P
                    });
                }
                else if (pathname === Const.URL_SECURITY) { // ⭐ 보안 관리 전용 세팅 추가
                    setItem({
                        depth1: null,
                        depth2: null,
                        type: Const.TYPE_L,
                        tab: "security" // 임의의 구분값 (필요시 Const에 추가)
                    });
                }
                else {
                    setItem({
                        depth1: menu && menu,
                        depth2: menu && menu.subMenus[0],
                        tab: Const.AD_B
                    });
                }
                setMenus(datas);
                localStorage.setItem(Const.LANG_TYPEA, lang);
            }
            else {
                alert("토큰이 만료되어 로그인으로 이동 합니다.");
                localStorage.removeItem(Const.TOKEN);
                navigate(Const.URL_LOGIN);
            }
            setReset(false);
        }
    }, [data, pathname]); // ⭐ pathname이 바뀔 때마다 실행되도록 의존성 배열 확인
    // 다국어 설정 
    const langSelect = (e) => __awaiter(this, void 0, void 0, function* () {
        const selectedLang = e.target.value;
        localStorage.setItem(Const.LANG_TYPEA, selectedLang);
        setLang(selectedLang);
        location.reload();
    });
    const LoginOut = () => {
        alert("로그아웃 되었습니다.");
        localStorage.removeItem(Const.TOKEN);
        location.reload();
    };
    return (_jsxs(_Fragment, { children: [_jsxs("header", Object.assign({ className: "manager-header" }, { children: [_jsx("div", Object.assign({ className: "lang" }, { children: _jsxs("select", Object.assign({ value: lang, onChange: (e) => langSelect(e) }, { children: [_jsx("option", Object.assign({ value: "KOR" }, { children: "KOR" })), _jsx("option", Object.assign({ value: "ENG" }, { children: "ENG" }))] })) })), _jsxs("div", Object.assign({ className: "title" }, { children: ["\uAD00\uB9AC\uC790 \uD398\uC774\uC9C0", (lang == Const.LANG_ENG && `(영문버젼)`)] })), _jsx("button", Object.assign({ className: "btn-add", onClick: LoginOut }, { children: "\uB85C\uADF8\uC544\uC6C3" }))] })), _jsx("div", Object.assign({ className: "manager-nav" }, { children: tab.map((item, idx) => (_jsx("button", Object.assign({ className: `admin-menu ${location.pathname === item.url ? "selected" : ""}`, onClick: () => navigate(item.url) }, { children: item.name }), "tab_" + idx.toString()))) }))] }));
}
